import { Container, FadeIn, RootLayout } from "@/aptim/aptim";
import { gql } from "@apollo/client/index.js";
import { LoaderFunctionArgs } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import { formatDate } from "date-fns";
import { ContactSection } from "~/components/ui/ContactSection";
import { client } from "~/utils/apollo";

export async function loader({ params }: LoaderFunctionArgs) {
  const slug = params.slug;
  const PostQuery = gql`
    query GetPostBySlut($id: ID!) {
      post(id: $id, idType: SLUG) {
        date
        content
        title
        slug
        featuredImage {
          node {
            sourceUrl(size: MEDIUM)
          }
        }
      }
    }
  `;

  const response = await client.query({
    query: PostQuery,
    variables: {
      id: slug,
    },
  });

  const post = response?.data?.post;
  return post;
}

export default function BlogPost() {
  const post = useLoaderData<typeof loader>();
  return (
    <RootLayout>
      <Container
        as="article"
        className="sm:mt-32 lg:mt-40 bg-white border-primary border-[1px] rounded-2xl opacity-90 mx-10"
      >
        <FadeIn>
          <header className="mx-auto flex max-w-5xl flex-col text-center pt-4">
            <div className="flex flex-row">
              <h1 className="mt-6 font-display text-5xl font-medium tracking-tight text-neutral-950 [text-wrap:balance] sm:text-6xl">
                {post.title}
              </h1>
              <img
                src={post.featuredImage?.node.sourceUrl}
                className="rounded-lg"
              />
            </div>
            <time
              dateTime={post.date}
              className="order-first text-sm text-neutral-950"
            >
              {formatDate(post.date, "PPP")}
            </time>
            {/* <p className="mt-6 text-sm font-semibold text-neutral-950">
              by {post.author.node.name}
            </p> */}
          </header>
        </FadeIn>
        <FadeIn>
          <div className="max-w-[900px] mx-auto p-4">
            <span
              className="mt-4 space-y-2 bg-white rounded-lg prose"
              dangerouslySetInnerHTML={{ __html: post.content }}
            />
          </div>
        </FadeIn>
      </Container>
      <ContactSection />
    </RootLayout>
  );
}
